import { useEffect } from "react";
import { UseFormReset } from "react-hook-form";
import type { components } from "@entities/journal";

// eslint-disable-next-line @typescript-eslint/naming-convention
type useResetterTitleProps = {
  data?: {
    mainJournal?: components["schemas"]["MainJournalViewResponseDto"];
  };
  reset: UseFormReset<{
    journalnumber: string;
    projectCharacteristics: string;
    constructionStartDate: string;
    constructionEndDate: string;
    mainJournalStartDate: string;
    mainJournalEndDate: string;
  }>;
};

export const useResetterTitle = ({ data, reset }: useResetterTitleProps) => {
  useEffect(() => {
    if (data) {
      reset((prevValues) => ({
        journalnumber:
          prevValues.journalnumber ||
          data?.mainJournal?.titleJournal?.mainJournalNumber ||
          "",
        projectCharacteristics:
          prevValues.projectCharacteristics ||
          data?.mainJournal?.titleJournal?.projectCharacteristics ||
          "",
        constructionStartDate:
          prevValues.constructionStartDate ||
          data?.mainJournal?.titleJournal?.constructionStartDate ||
          "",
        constructionEndDate:
          prevValues.constructionEndDate ||
          data?.mainJournal?.titleJournal?.constructionEndDate ||
          "",
        mainJournalStartDate:
          prevValues.mainJournalStartDate ||
          data?.mainJournal?.titleJournal?.mainJournalStartDate ||
          "",
        mainJournalEndDate:
          prevValues.mainJournalEndDate ||
          data?.mainJournal?.titleJournal?.mainJournalEndDate ||
          "",
      }));
    }
  }, [data, reset]);
};

